<section id='cover' class="cover-part">

    <div class="content">
        <h1 @fadeIn >{{textService.getText('fooldal_motto_title')}}</h1>
        <div @fadeIn>{{textService.getText('fooldal_motto_subtitle')}}</div>
    </div>
    
</section>